// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__2_fqq","error_block":"styles_error_block__3GMHJ","text":"styles_text__2XIFc"};